import { ValidationMessage } from "./States.js";

interface FormFieldProps {
  id: string;
  label: string;
  type?: string;
  value: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  hint?: string;
  required?: boolean;
  autoComplete?: string;
  inputMode?: any;
  placeholder?: string;
  name?: string;
  as?: "input" | "textarea";
  rows?: number;
}

export function FormField({
  id,
  label,
  type = "text",
  value,
  onChange,
  onBlur,
  error,
  hint,
  required,
  autoComplete,
  inputMode,
  placeholder,
  name,
  as = "input",
  rows = 4,
}: FormFieldProps) {
  const describedBy = [hint ? `${id}-hint` : null, error ? `${id}-error` : null].filter(Boolean).join(" ") || undefined;
  const commonProps = {
    id,
    name: name || id,
    value,
    required,
    autoComplete,
    placeholder,
    "aria-invalid": error ? true : undefined,
    "aria-describedby": describedBy,
    onChange: onChange ? (e: any) => onChange(e.target.value) : undefined,
    onBlur,
  };
  return (
    <div className="form-field">
      <label htmlFor={id}>
        {label}
        {required ? " *" : ""}
      </label>
      {as === "textarea" ? (
        <textarea className="form-textarea" rows={rows} {...commonProps} />
      ) : (
        <input className="form-input" type={type} inputMode={inputMode} {...commonProps} />
      )}
      {hint && (
        <p className="form-hint" id={`${id}-hint`}>
          {hint}
        </p>
      )}
      <ValidationMessage id={error ? `${id}-error` : undefined}>{error}</ValidationMessage>
    </div>
  );
}
